<template>
  <div class="menu menuPadding">
    <template v-if="showHomeComponents">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.mdAndUp"></v-col>
        <v-col :cols="11">
          <v-row no-gutters class="mb-6">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-account-supervisor</v-icon>
            </v-col>
            <v-col>
              <h2 class="menuHeaders">Lead Management Hierarchy</h2>
              <v-flex>View and edit agency hierarchies.</v-flex>
              <router-link to="/hierarchy" class="menuLinks">
                <v-btn color="green" dark class="menuBtn"
                  >View &amp; Edit Hierarchies</v-btn
                >
              </router-link>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-6" v-if="isHomeOfficeUser">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-account-convert</v-icon>
            </v-col>
            <v-col>
              <h2 class="menuHeaders">Manage Agency Owners</h2>
              <v-flex>Replace an Agency Owner</v-flex>
              <router-link to="/replace" class="menuLinks">
                <v-btn color="green" dark class="menuBtn">Replace AO</v-btn>
              </router-link>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-6" v-if="isEditUser">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-lead-pencil</v-icon>
            </v-col>
            <v-col>
              <h2 class="menuHeaders">
                Agency Office Name &amp; Address Editor
              </h2>
              <v-flex>Edit agency names, addresses and phone numbers.</v-flex>
              <router-link to="/agency" class="menuLinks">
                <v-btn color="green" dark class="menuBtn"
                  >Edit Agency Office Information</v-btn
                >
              </router-link>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-6" v-if="isHomeOfficeUser">
            <v-col
              v-if="$vuetify.breakpoint.smAndUp"
              :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
            >
              <v-icon size="60" color="#00558C">mdi-history</v-icon>
            </v-col>
            <v-col>
              <v-badge
                color="red"
                :content="numNewAgencyChanges"
                v-if="numNewAgencyChanges > 0"
              >
                <h2 class="menuHeaders">Agency Office Updates History</h2>
              </v-badge>
              <h2 class="menuHeaders" v-if="numNewAgencyChanges == 0">
                Agency Office Updates History
              </h2>
              <v-flex
                >View agency owner, name, address &amp; phone number
                changes.</v-flex
              >
              <router-link to="/history" class="menuLinks">
                <v-btn color="green" dark class="menuBtn">View History</v-btn>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <br /><br /><br />
    </template>
    <template v-else-if="giveUserOption">
      <v-row no-gutters class="mb-6">
        <v-col
          v-if="$vuetify.breakpoint.smAndUp"
          :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
        >
          <v-icon size="60" color="#00558C">mdi-account-supervisor</v-icon>
        </v-col>
        <v-col>
          <h2 class="menuHeaders">FHD Lead Management Hierarchy</h2>
          <v-btn color="green" dark class="menuBtn" @click="showHome = true"
            >FHD Lead Management Hierarchy</v-btn
          >
        </v-col>
      </v-row>
      <v-row no-gutters class="mb-6">
        <v-col
          v-if="$vuetify.breakpoint.smAndUp"
          :cols="$vuetify.breakpoint.smAndDown ? 2 : 1"
        >
          <v-icon size="60" color="#00558C">mdi-account-details</v-icon>
        </v-col>
        <!-- <v-col>
          <h2 class="menuHeaders">LNL Administration</h2>
          <v-btn
            color="green"
            dark
            class="menuBtn"
            @click="$router.push('/lnladmin')"
            >LNL Administration</v-btn
          >
        </v-col> -->
      </v-row>
    </template>

    <v-progress-circular
      indeterminate
      color="green"
      v-if="waitCircle"
      size="50"
      class="waitCircle"
    ></v-progress-circular>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import utilityMixins from "@/utility-mixins.js";
import { HTTP, HTTP_GAP, HTTP_LND } from "@/http-common.js";
import EventBus from "@/eventBus.js";
import RecognizedRoles from "@/roles.js";

export default {
  mixins: [utilityMixins],
  computed: {
    showHomeComponents() {
      return this.showHome;
    },
    giveUserOption() {
      return this.giveOption;
    },
    lnlUser() {
      if (this.$store.state.userRoles == null) {
        return false;
      }
      let roles = this.$store.state.userRoles.split(",");
      for (let role of roles) {
        if (role == RecognizedRoles.roles.LNLAdmin) {
          return true;
        }
      }
      return false;
    },
    fhdUser() {
      if (this.$store.state.userRoles == null) {
        return false;
      }
      let roles = this.$store.state.userRoles.split(",");
      for (let role of roles) {
        if (role.startsWith(RecognizedRoles.roles.CommonPrefix) || role == RecognizedRoles.roles.IAMAdmin) {
          return true;
        }
      }
      return false;
    },
  },
  data() {
    return {
      showHome: false,
      numNewAgencyChanges: 0,
      waitCircle: true,
      giveOption: false,
    };
  },
  created() {
    if (
      !this.$route.query.accesscode &&
      window.sessionStorage.getItem("jwt") == null
    ) {
      this.waitCircle = false;
      this.checkAuthentication();
    }
  },
  mounted() {
    let jwt = window.sessionStorage.getItem("jwt");
    if (jwt == "invalid_jwt" && !this.$route.query.accesscode) {
      this.$router.push("/unauthenticated");
    } else if (this.$route.query.accesscode) {
      this.checkJWTAuthentication();
    } else {
      if (
        this.$store.state.currentUser &&
        this.$store.state.currentUser.agentNum &&
        this.$store.state.currentUser.agentNum != ""
      ) {
        HTTP.get("views", {
          params: {
            company: this.$store.state.currentCompany,
            userId: this.$store.state.currentUser.agentNum,
          },
        })
          .then((results) => {
            this.numNewAgencyChanges = results.data.numRecords;
            this.$store.commit("setAgencyChanges", results.data.records);
          })
          .catch((e) => {
            this.addToErrorLogs("Home mounted get views", e);
          });
      }
    }
  },
  methods: {
    checkJWTAuthentication() {
      if (!this.$route.query.accesscode) return;

      this.waitCircle = true;

      this.$store.commit("setCurrentUser", null);
      window.sessionStorage.removeItem("currentUser");

      EventBus.$emit("setUserName", null);

      this.$store.commit("setUserRoles", null);
      window.sessionStorage.removeItem("primaryAgentNum");

      this.$store.commit("setJWT", null);
      window.sessionStorage.removeItem("jwt");

      this.$store.commit("setTmkClientId", null);
      window.sessionStorage.removeItem("tmkClientId");

      // --------for testing----------

      if (this.$route.query.accesscode.endsWith("-TE5E")) {
        // LND Recruiting

        // EventBus.$emit("setIsJWTAuthenticated", true);

        // window.sessionStorage.setItem("isJWTAuth", JSON.stringify(true));

        // this.$store.commit("setTmkClientId", "12345");
        // window.sessionStorage.setItem("tmkClientId", "12345");

        // this.$store.commit("setCurrentUser", {
        //   name: "TEST" + " " + "USER",
        // });

        // window.sessionStorage.setItem(
        //   "currentUser",
        //   JSON.stringify({
        //     name: "TEST" + " " + "USER",
        //   })
        // );

        // EventBus.$emit("setUserName", "TEST" + " " + "USER");

        // this.$store.commit("setJWT", "valid jwt here");
        // window.sessionStorage.setItem("jwt", "valid jwt here");

        // this.$router.push("/recruiting");

        try {
          HTTP_LND.post("exchangeaccesscode", {
            accessCode: this.$route.query.accesscode,
          })
            .then((results) => {
              if (results.status == 200) {
                this.$store.commit(
                  "setAccessCode",
                  this.$route.query.accesscode
                );

                EventBus.$emit("setIsJWTAuthenticated", true);

                this.$store.commit("setTmkClientId", results.data.tmkClientId);
                window.sessionStorage.setItem(
                  "tmkClientId",
                  results.data.tmkClientId
                );

                EventBus.$emit("setTmkClientId", results.data.tmkClientId);

                this.$store.commit("setCurrentUser", {
                  name:
                    results.data.agentFirstName +
                    " " +
                    results.data.agentLastName,
                });

                window.sessionStorage.setItem(
                  "currentUser",
                  JSON.stringify({
                    name:
                      results.data.agentFirstName +
                      " " +
                      results.data.agentLastName,
                  })
                );

                EventBus.$emit(
                  "setUserName",
                  results.data.agentFirstName + " " + results.data.agentLastName
                );

                this.$store.commit("setJWT", results.data.jwt);
                window.sessionStorage.setItem("jwt", results.data.jwt);

                this.$router.push("/recruiting");
              } else {
                this.$store.commit("setAccessCode", null);
                window.sessionStorage.removeItem("accessCode");
                EventBus.$emit("setIsJWTAuthenticated", false);
                this.$router.push("/unauthenticated");
              }
            })
            .catch((err) => {
              this.$store.commit("setAccessCode", null);
              window.sessionStorage.removeItem("accessCode");
              this.addToErrorLogs("Home.vue checkAuthentication", err);
              EventBus.$emit("setIsJWTAuthenticated", false);
              this.$router.push("/unauthenticated");
            });
        } catch (err) {
          this.$store.commit("setAccessCode", null);
          window.sessionStorage.removeItem("accessCode");
          this.addToErrorLogs("Home.vue checkAuthentication", err);
          EventBus.$emit("setIsJWTAuthenticated", false);
          this.$router.push("/unauthenticated");
        }
      } else {
        // ------------------------------
        // GAP

        try {
          HTTP_GAP.post("exchangeaccesscode", {
            accessCode: this.$route.query.accesscode,
          })
            .then((results) => {
              if (results.status == 200) {
                EventBus.$emit("setIsJWTAuthenticated", true);

                this.$store.commit("setTmkClientId", results.data.tmkClientId);
                window.sessionStorage.setItem(
                  "tmkClientId",
                  results.data.tmkClientId
                );
                EventBus.$emit("setTmkClientId", results.data.tmkClientId);

                this.$store.commit("setCurrentUser", {
                  name:
                    results.data.agentFirstName +
                    " " +
                    results.data.agentLastName,
                });

                window.sessionStorage.setItem(
                  "currentUser",
                  JSON.stringify({
                    name:
                      results.data.agentFirstName +
                      " " +
                      results.data.agentLastName,
                  })
                );

                EventBus.$emit(
                  "setUserName",
                  results.data.agentFirstName + " " + results.data.agentLastName
                );

                this.$store.commit("setJWT", results.data.jwt);
                window.sessionStorage.setItem("jwt", results.data.jwt);

                this.$router.push("/gap");
              } else {
                this.$store.commit("setAccessCode", null);
                window.sessionStorage.removeItem("accessCode");
                EventBus.$emit("setIsJWTAuthenticated", false);
                this.$router.push("/unauthenticated");
              }
            })
            .catch((err) => {
              this.$store.commit("setAccessCode", null);
              window.sessionStorage.removeItem("accessCode");
              this.addToErrorLogs("Home.vue checkAuthentication", err);
              EventBus.$emit("setIsJWTAuthenticated", false);
              this.$router.push("/unauthenticated");
            });
        } catch (err) {
          this.$store.commit("setAccessCode", null);
          window.sessionStorage.removeItem("accessCode");
          this.addToErrorLogs("Home.vue checkAuthentication", err);
          EventBus.$emit("setIsJWTAuthenticated", false);
          this.$router.push("/unauthenticated");
        }
      }
    },

    checkAuthentication() {
      if (this.$route.query.accesscode) {
        return;
      } else {
        if (
          window.sessionStorage.getItem("tmkClientId") != null &&
          window.sessionStorage.getItem("tmkClientId") != ""
        ) {
          this.$router.push("/gap");
          return;
        } else {
          Auth.currentAuthenticatedUser()
            .then((user) => {
              if (!user || this.$store.state.userRoles == "") {
                if (this.$route.query.code) {
                  this.$router.push("/login?code=" + this.$route.query.code);
                  return;
                } else {
                  this.$router.push("/login");
                  return;
                }
              }
              // if (this.fhdUser && !this.lnlUser) {
              if (this.fhdUser) {
                if (this.isAgencyUser) {
                  this.$router.push("/hierarchy");
                  return;
                } else this.showHome = true;
                // } else if (this.lnlUser && !this.fhdUser) {
                //   this.$router.push("/lnladmin");
                // } else if (this.lnlUser && this.fhdUser) {
                //   this.giveOption = true;
              } else {
                if (this.$route.query.code) {
                  this.$router.push("/login?code=" + this.$route.query.code);
                } else {
                  this.$router.push("/login");
                }
              }
            })
            .catch(() => {
              if (this.$route.query.code) {
                this.$router.push("/login?code=" + this.$route.query.code);
              } else {
                this.$router.push("/login");
              }
            });
        }
      }
    },
  },
};
</script>
<style scoped>
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 45%;
  left: 47%;
  margin-top: 200px;
}
.menuHeaders {
  color: #00558c;
}
.menu {
  margin-left: 50px;
}
.menuPadding {
  margin-top: 100px;
}
.menuBtn {
  margin-top: 10px;
  text-transform: none !important;
  letter-spacing: normal;
  border-radius: 20px;
}
.disabledPointer {
  cursor: default;
}
.menuLinks {
  text-decoration: none !important;
  color: inherit;
}
.wrap {
  word-wrap: break-word !important;
}
</style>
